// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--Q1NyZ{0%{background-position:200% 0}100%{background-position:-200% 0}}.slide-video-preview--hRQDF{width:100%;cursor:pointer;position:relative}.slide-video-preview--hRQDF.vertical--yyI_x{padding-bottom:177.78%}.slide-video-preview--hRQDF.square--AP_qU{padding-bottom:100%}.slide-video-preview--hRQDF.landscape--_vMF3{padding-bottom:56.25%}.slide-video-preview--hRQDF.fourfive--nt0lb{padding-bottom:125%}.slide-video-preview--hRQDF canvas{position:absolute;width:100%;height:100%;border:2px solid #f0f0f4;border-radius:2px}.slide-video-preview--hRQDF.active--FMBYW canvas{border-color:#5645f5;border-width:3px;border-radius:8px}.slide-video-preview--hRQDF .draft--nyzZv{position:absolute;right:5px;top:5px;background:#db2b28;color:#fff;padding:1px 4px;z-index:1;border-bottom-left-radius:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slide-video-preview": "slide-video-preview--hRQDF",
	"vertical": "vertical--yyI_x",
	"square": "square--AP_qU",
	"landscape": "landscape--_vMF3",
	"fourfive": "fourfive--nt0lb",
	"active": "active--FMBYW",
	"draft": "draft--nyzZv",
	"shimmer-loading": "shimmer-loading--Q1NyZ"
};
export default ___CSS_LOADER_EXPORT___;
